import React from 'react';
import { Link } from 'react-router-dom';

const RenderOverview = props => {
    const { work, active } = props;

    if (work.length > 0) {
        return work.map(function(post, index) {
            return (
                <article
                    key={post.id}
                    id={`post-${post.id}`}
                    className={`post-${post.id} work-article image-bg ${
                        active ? 'fadeIn' : ''
                    }`}>
                    <div className="post-container">
                        <div className="image-container">
                            {post.better_featured_image && (
                                <picture>
                                    {!!post.better_featured_image.media_details
                                        .sizes.img_overview_wide && (
                                        <React.Fragment>
                                            <source
                                                media="(max-width: 767px)"
                                                srcSet={
                                                    post.better_featured_image
                                                        .media_details.sizes
                                                        .img_overview_wide
                                                        .source_url
                                                }
                                            />
                                            <img
                                                className="img-responsive"
                                                src={
                                                    post.better_featured_image
                                                        .media_details.sizes
                                                        .img_overview_wide
                                                        .source_url
                                                }
                                                alt={`featured ${post.title.rendered} Friends for Brands`}
                                            />
                                        </React.Fragment>
                                    )}
                                </picture>
                            )}
                            <div className="title-container">
                                <h2>{post.title.rendered}</h2>
                                <Link
                                    className="cta-btn"
                                    to={{
                                        pathname: `/work/${post.slug}`,
                                        state: { transition: 'fade' },
                                    }}>
                                    View case
                                </Link>
                            </div>
                        </div>
                    </div>
                </article>
            );
        });
    } else {
        return (
            <div className="overviewpage__emptycontainer">
                <span>
                    We're so sorry! Unfortunately we have no cases in this
                    category yet. <br />
                    Try to filter again with an alternative category.
                </span>
            </div>
        );
    }
};
export default RenderOverview;



// WEBPACK FOOTER //
// ./src/components/Pages/WorkOverview/RenderOverview.jsx